import { Box, Button, IconButton, Stack } from '@mui/material';
import { FC, useRef, useState } from 'react';
import { IconDeleteCanOutline, IconDownload, IconUpload } from '../../../common/icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ENDPOINT_BASE_URL } from '../../../common/constants';

export const FileUpload: FC<{
  handleChangeInput: any;
  handleDelete: (e: any) => void;
  item: any;
  currentName?: string;
  acceptedFiles: string;
}> = ({ handleChangeInput, handleDelete, item, currentName, acceptedFiles }) => {
  const ref = useRef<any>(null);
  const { t } = useTranslation();
  const [, forceUpdate] = useState(false);

  const handleDeleteItem = () => {
    ref.current.value = '';
    forceUpdate((prev) => !prev);
    handleDelete(item);
  };

  return (
    <Stack direction="row" gap={1}>
      <Button
        fullWidth
        disabled={ref?.current?.value || currentName}
        onClick={() => ref.current.click()}
        variant="outlined"
        startIcon={<IconUpload />}
      >
        {t(`wanted-list.type.${item}`)}
      </Button>
      <Box
        component={Link}
        to={`${ENDPOINT_BASE_URL}/images/${currentName}`}
        download
        sx={{ text: 'none' }}
        target="_blank"
        minWidth={170}
      >
        <Button fullWidth disabled={!!!currentName} variant="outlined" startIcon={<IconDownload />}>
          {t(`wanted-list.type.${item}`)}
        </Button>
      </Box>

      <input
        ref={ref}
        accept={acceptedFiles}
        type="file"
        style={{ display: 'none' }}
        onChange={handleChangeInput}
        placeholder="asd"
      />
      <IconButton
        disabled={!Boolean(currentName) && !ref?.current?.value}
        color="error"
        onClick={() => handleDeleteItem()}
      >
        <IconDeleteCanOutline />
      </IconButton>
    </Stack>
  );
};
